var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClippingCircleMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 566.9 566.9",
    style: {
      enableBackground: "new 0 0 566.9 566.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M475,74.5C359.5-31.3,180.2-23.5,74.5,92C-31.3,207.4-23.5,386.7,92,492.5c115.4,105.8,294.7,97.9,400.5-17.5 C598.2,359.5,590.4,180.2,475,74.5z M409.9,399.3c-64,69.8-172.5,74.6-242.3,10.6l0,0C97.8,345.9,93,237.4,157,167.6 C221,97.8,329.5,93,399.3,157l0,0C469.2,221,473.9,329.5,409.9,399.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClippingCircleMask);
export default __webpack_public_path__ + "static/media/Clipping_circle_mask.596715935942339ca46a4f28e24eb763.svg";
export { ForwardRef as ReactComponent };